import React, { useMemo } from 'react';
import DesktopCategoryRow from './DesktopCategoryRow';
import DesktopSectionSlider from './DesktopSectionSlider';
import DesktopShowcase from './DesktopShowcase';
import DesktopTestimonials from './DesktopTestimonials';

const DesktopHomeContent = ({ 
  products, 
  categories,
  selectedCategory,
  setSelectedCategory,
  sortBy,
  setSortBy,
  viewMode,
  setViewMode,
  currentPage,
  handlePageChange,
  totalPages,
  showFilters,
  setShowFilters,
  loading,
  handleAddToCart,
  handleToggleWishlist,
  handleStartChat,
  wishlist,
  bestSellers = [],
  newestProducts = [],
  showCategories = true
}) => {
  
  const displayBestSellers = useMemo(() => {
    if (bestSellers && bestSellers.length > 0) return bestSellers;
    if (!products) return [];
    return [...products]
      .sort((a, b) => (Number(b?.reviewCount) || 0) - (Number(a?.reviewCount) || 0))
      .slice(0, 10);
  }, [products, bestSellers]);

  const displayNewest = useMemo(() => {
    if (newestProducts && newestProducts.length > 0) return newestProducts;
    if (!products) return [];
    return products.slice(0, 10); // Assuming API returns newest first or we can sort by date if available
  }, [products, newestProducts]);

  return (
    <div className="py-12 space-y-16">
      {/* 1. Popular Categories */}
      {showCategories ? (
        <section>
          <DesktopCategoryRow categories={categories} />
        </section>
      ) : null}

      {/* 2. Best Sellers */}
      <section>
        <DesktopSectionSlider 
            title="پرفروش‌ترین‌ها" 
            items={displayBestSellers} 
            linkTo="/search?sort=best_selling" 
        />
      </section>

      {/* 3. Newest Products */}
      <section>
        <DesktopSectionSlider 
            title="جدیدترین‌ها" 
            items={displayNewest} 
            linkTo="/search?sort=newest" 
        />
      </section>

      {/* 4. Product Showcase */}
      <section>
        <DesktopShowcase products={products} />
      </section>

      {/* 5. Customer Reviews */}
      <section>
        <DesktopTestimonials />
      </section>
    </div>
  );
};

export default DesktopHomeContent;
